export default __webpack_public_path__ + "static/media/pexels-mnz-1598505-min.b8ca118b.jpg";